import loadable from '@loadable/component';

// 懒加载组件
const ItemChargeDetailQuery = loadable(() => import('./itemChargeDetailQuery/ItemChargeDetailQuery'));
const HospitalInventoryQuery = loadable(() => import('./hospitalInventoryQuery/HospitalInventoryQuery'));

export const subRoutes = [
  { // 耗材计费信息查询
    path: '/ItemChargeDetailQuery',
    component: ItemChargeDetailQuery
  },
  { // 医院库存查询
    path: '/HospitalInventoryQuery',
    component: HospitalInventoryQuery
  }
];
